import React from "react";

import { LANGUAGE_CONFIG, UI_COPY } from "../../../../config";
import { useUiText } from "../../../../hooks/useUiText";
import { useWorkDescriptionTranslation } from "../useWorkDescriptionTranslation";

/**
 * Read-only Spanish translation of a work description.
 * Never writes the translation back into `workDescription`.
 *
 * @param {Object} props Component props.
 * @param {string} [props.text=""] Source work description (English or Spanish).
 * @returns {JSX.Element|null} Stacked translation preview for Spanish users, otherwise nothing.
 */
const WorkDescriptionTranslation = ({ text = "" }) => {
  const { language, t } = useUiText();
  const trimmedText = (text || "").trim();
  const hasText = Boolean(trimmedText);
  const { translatedText, detectedSourceLanguage, error } =
    useWorkDescriptionTranslation(text, {
      debounceMs: 500,
    });
  const hideAsAlreadySpanish = detectedSourceLanguage === LANGUAGE_CONFIG.SPANISH;
  const showPreview = hasText && !hideAsAlreadySpanish;

  if (language !== LANGUAGE_CONFIG.SPANISH) {
    return null;
  }

  return (
    <div
      className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${
        showPreview ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="min-h-0 overflow-hidden">
        <div className="mt-2">
          <div className="border-t border-gray-200" />
          {/* <p className="block text-sm font-medium text-gray-700 mb-1">
            {t(UI_COPY.clockIn.workDescriptionTranslation)}
          </p> */}
          <p
            className="mt-1 pl-3 text-sm text-gray-500 whitespace-pre-wrap"
            aria-live="polite"
          >
            {translatedText}
          </p>
          {error ? (
            <p className="mt-1 text-xs text-red-600">
              {t(UI_COPY.clockIn.workDescriptionTranslationUnavailable)}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default WorkDescriptionTranslation;
